<template>
    <div class="text-left pa-6 logo">
        <div>
            <img src="@/assets/image/admin_logo.png">
            <span class="pl-1">TN-BOX</span>
        </div>
        <div class="mt-2">
{{ userName }}
</div>
    </div>
</template>

<script>
    export default {
        name: "NavigationSideHeader",
        props: {
            userName: {
                type: String,
            }
        }
    }
</script>

<style scoped>
    /*vertical side bar start*/
    >>> .v-tabs--vertical > .v-tabs-bar {
        width: 380px;
    }

    .v-tab.v-tab {
        justify-content: flex-start;
        color: white;
    }


    >>> .theme--light.v-tabs > .v-tabs-bar {
        background-color: #2B3F54;
    }

    .theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active), .theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-icon, .theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-btn, .theme--light.v-tabs > .v-tabs-bar .v-tab--disabled {
        color: white;
    }

    .v-tab:before {
        width: 380px;
    }

    >>> .v-tab {
        max-width: 380px !important;
    }

    /* 사이드바 메뉴 호버, 클릭시 화살표 나타나야함
    .v-tab:hover{
        background-image: url("/image/right_arrow.png");
    }
    */

    .logo {
        height: 110px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.15)
    }

    .logo > div > span {
        color: white;
        font-weight: bold;
        font-size: 14px;
    }

    .logo > div:nth-child(2) {
        color: white;
        font-weight: bold;
        font-size: 24px;
    }

    >>> html {
        height: 100% !important;
    }

    >>> body {
        height: 100% !important;
    }

    >>> v-tabs v-tabs--vertical theme--light {
        height: 100%;
    }

    /*vertical side bar end*/
</style>